{
  "name": "@vercel/flags-core",
  "version": "1.8.0",
  "description": "A server-side client for Vercel Flags",
  "keywords": [
    "vercel",
    "flags",
    "vercel flags",
    "feature flags",
    "flags sdk"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/vercel/flags.git"
  },
  "license": "MIT",
  "author": "Dominik Ferber <dominik@vercel.com>",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "next-js": {
        "types": "./dist/index.next-js.d.ts",
        "default": "./dist/index.next-js.js"
      },
      "import": {
        "types": "./dist/index.default.d.ts",
        "default": "./dist/index.default.js"
      },
      "require": {
        "types": "./dist/index.default.d.cts",
        "default": "./dist/index.default.cjs"
      }
    },
    "./openfeature": {
      "next-js": {
        "types": "./dist/openfeature.next-js.d.ts",
        "default": "./dist/openfeature.next-js.js"
      },
      "import": {
        "types": "./dist/openfeature.default.d.ts",
        "default": "./dist/openfeature.default.js"
      },
      "require": {
        "types": "./dist/openfeature.default.d.cts",
        "default": "./dist/openfeature.default.cjs"
      }
    }
  },
  "main": "./dist/index.default.js",
  "typesVersions": {
    "*": {
      ".": [
        "dist/index.default.d.ts",
        "dist/index.default.d.cts"
      ],
      "openfeature": [
        "dist/openfeature.default.d.ts",
        "dist/openfeature.default.d.cts"
      ]
    }
  },
  "files": [
    "dist",
    "CHANGELOG.md"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "check": "biome check",
    "test": "vitest --run",
    "test:watch": "vitest",
    "type-check": "tsc --noEmit"
  },
  "dependencies": {
    "@vercel/functions": "^3.4.3",
    "@vercel/oidc": "3.5.0",
    "jose": "5.2.1",
    "js-xxhash": "4.0.0"
  },
  "devDependencies": {
    "@arethetypeswrong/cli": "0.18.2",
    "@types/node": "22.14.0",
    "next": "^16.2.12",
    "tsup": "8.5.1",
    "typescript": "5.6.3",
    "vite": "8.1.5",
    "vitest": "4.1.10"
  },
  "peerDependencies": {
    "@openfeature/server-sdk": "1.18.0",
    "next": "*"
  },
  "peerDependenciesMeta": {
    "@openfeature/server-sdk": {
      "optional": true
    },
    "next": {
      "optional": true
    }
  },
  "publishConfig": {
    "access": "public"
  }
}
